import React, { useState } from 'react';
import { Button, Modal, ProgressBar } from 'react-bootstrap';
import closeImg from "Common/img/SVG/WireframesArtboard 1.svg";
import closeActiveImg from 'Common/img/SVG/WireframesDisabled Tab.svg';
import classNames from "classnames";
import moment from 'moment';
import { STANDARD_DATE_TIME_FORMAT, STANDARD_DATE_FORMAT } from '../constants/commonConstants';
import { TiArrowSortedUp } from "@react-icons/all-files/ti/TiArrowSortedUp";
import { TiArrowSortedDown } from "@react-icons/all-files/ti/TiArrowSortedDown";

export const CloseIconComponent = ({ close, isActive }) => {
    let imgAddr = isActive ? closeImg : closeActiveImg;
    return (
        <div className="close-icon">
            <img onClick={() => { close() }} className="float-right close-icon-size" src={imgAddr} alt="Close"></img>
        </div>
    )

}
export const MessageModalComponent = ({ title, message, show, onHide, showOkayBtn,contentClassName,titleClassName,modalHeaderClassName }) => {
    return (
        <Modal show={show} backdrop="static"
        keyboard={false} contentClassName={contentClassName ?? "loader-modal-size"} centered= {true}>
        <Modal.Header className={modalHeaderClassName ?? "beck-modal-header"}>
                <Modal.Title className={titleClassName ?? "beck-modal-title"}>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex">
                <div className="d-flex align-items-center justify-content-center message-modal" >
                    <div>{message}</div>
                </div>
            </Modal.Body>
            {showOkayBtn && <Modal.Footer className="beck-modal-footer">
                <Button variant="primary" size="lg" onClick={onHide}>OK</Button>
            </Modal.Footer>
            }
        </Modal>
    )
}

export const PlaceHolderLoader = ({ numRows }) => {
    return (
        <div className="ph-item">
            <div className="ph-col-12">
                <div className="ph-row">
                    {

                        Array(numRows).fill().map((elem, idx) => <div key={idx + "_placeholder_" + Math.random()} className="ph-col-12 big"></div>)
                    }
                </div>
            </div>
        </div>
    )
}
export const MessageModalWithProgressComponent = ({ title, message, show, status, type }) => {
    let contentClassClass = classNames({
        'loader-modal-size': true,
        '': (type !== 'info'),
        'modal-info': (type === 'info')
    });
    let headerClass = classNames({
        'beck-modal-header': true,
        'modal-info-header': (type === 'info')
    })
    let headerTitleClass = classNames({
        "beck-modal-title": true,
        'modal-info-title': (type === 'info')
    })
    return (
        <Modal show={show} backdrop="static"
            keyboard={false} contentClassName={contentClassClass} centered="true">
            <Modal.Header className={headerClass}>
                <Modal.Title className={headerTitleClass}>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex">
                <div className="d-flex align-items-center justify-content-center" style={{ 'height': '90%', 'width': '100%', 'flexDirection': 'column' }}>
                    <div style={{ width: '75%' }}>
                        <ProgressBar variant="info" now={status} min={0} max={100} />
                    </div>
                    <div>{message}</div>
                </div>
            </Modal.Body>
        </Modal>
    )
}


export const getUTCToLocalDate = (date) => {
    if (date)
        return moment.utc(date).local().format(STANDARD_DATE_TIME_FORMAT)
}

export const convertUTCDateTimeToLocalDate = (date) => {
    if (date)
        return moment.utc(date).local().format(STANDARD_DATE_FORMAT)
}

/**
 * functional component used to display the header column of control material table
 * @param {Object} props received from the parent component
 * @param {string} props.instrTimeZone is the timezone in which the instrument is situated
 * @param {string} props.deviceId is the device or instance id of the device
 * @param {string} props.modelName is the model name of the device
 * @param {Object} props.filterData where key is the assay name string and value is the toDate string
 * dumb component
 * @returns jsx to be rendered
 */
export function TableHeaderCol({
    sortConfig,
    field,
    label,
    onSortChange,
    className,
  }) {
    return (
      <th
        role="columnheader"
        className={className}
        onClick={() => {
          onSortChange(
            sortConfig.field === field ? -1 * sortConfig.order : -1,
            field
          );
        }}
      >
        <span><b>{label}</b></span>
        <span>
          {sortConfig.field === field &&
            (sortConfig.order === -1 ? (
              <TiArrowSortedUp />
            ) : (
              <TiArrowSortedDown />
            ))}
        </span>
      </th>
    );
  }

export const ConfirmationPopupModal = ({ isDisplayed, title, message, cancelAction, okAction, okLabel = "OK", cancelLabel = "Cancel" }) => {
    return (
        <Modal show={isDisplayed} backdrop="static" keyboard={false} contentClassName="file-access-modal-size" centered="true">
            <Modal.Header >
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <div className="text-center file-access-modal-body" >
                    <div style={{ marginTop: '15px', marginBottom: '38px' }}><span>{message}</span></div>
                </div>
            </Modal.Body>
            <div className="file-access-modal-border"></div>
            <Modal.Footer className="file-access-modal-footer" >
                <span className='file-access-modal-btn-left'><Button className='file-access-modal-button' variant="primary" size="lg" onClick={cancelAction}>{cancelLabel}</Button> </span>
                <span className='file-access-modal-btn-right'><Button className='file-access-modal-button' variant="primary" size="lg" onClick={okAction}>{okLabel}</Button> </span>
            </Modal.Footer>
        </Modal>
    )
}